import nProgress from 'nprogress';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import '../../styles/nprogress.css';
import useAppTheme from './useAppTheme';

nProgress.configure({ showSpinner: false });
nProgress.setColor = (color) => {
  const style = document.createElement('style');
  style.textContent = `
  #nprogress .bar {
    background: ${color} !important;
  }
  `;
  document.body.appendChild(style);
};

export function useNProgress() {
  const location = useLocation();
  const theme = useAppTheme();

  useEffect(() => {
    nProgress.setColor(theme.palette.primary.main);
    nProgress.start();
    // Simulate "routeChangeComplete" after navigation
    setTimeout(() => {
      nProgress.done();
    }, 100);
  }, [location]);
}